import { useEffect, useState } from 'react'

import { clientAssign } from 'experiments/clientExperimentService'
import { EXPERIMENT_NAME, GROUP_NAME } from 'experiments/constants/Experiments'
import { useExperimentDispatch, useExperimentState } from 'experiments/hooks/useExperiment'
import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'
import { FeatureFlag } from 'shared/enums/FeatureFlag'
import { stringify } from 'shared/lib/safeJSON'

/**
 *
 * @param experimentName Darwin experiment name
 * @param forceDisable If true, it forces the service to be disabled
 */
export const useStartExperiment = (
  experimentName: EXPERIMENT_NAME,
  forceDisable: boolean = false,
) => {
  const areExperimentsEnabled = useFeatureFlag(FeatureFlag.WEB_FC_ENABLE_EXPERIMENTS)
  const enableExperiment = areExperimentsEnabled && !forceDisable
  const experimentDispatch = useExperimentDispatch()
  const experimentState = useExperimentState()
  const [isAssigning, setIsAssigning] = useState<boolean>(
    enableExperiment && !experimentState[experimentName],
  )

  useEffect(() => {
    const assignGroup = async () => {
      try {
        setIsAssigning(true)
        const data = await clientAssign(experimentName)
        experimentDispatch({
          type: 'assignGroup',
          payload: { experimentName, groupAssigned: data?.name as GROUP_NAME },
        })
        setIsAssigning(false)
      } catch (error) {
        setIsAssigning(false)
        experimentDispatch({
          type: 'setError',
          payload: { experimentName, error: stringify(error) },
        })
      }
    }

    if (enableExperiment && !experimentState[experimentName]) {
      experimentDispatch({
        type: 'startExperiment',
        payload: { experimentName },
      })
      assignGroup()
    }
  }, [enableExperiment, experimentDispatch, experimentName, experimentState])

  return { experimentState: experimentState?.[experimentName], isAssigning }
}
